import { action, observable } from 'mobx'

import Ds from './ds'

class Service {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllService() {
    this.ds.query(`{ service(hash: "${ localStorage.getItem('userHash') }") { id name description baseCost } }`, (data) => {
      this.data = data.service
    })
  }

  @action newService(row) {
    this.ds.query(`mutation { addService(name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllService()
    })
  }

  @action updateService(row) {
    this.ds.query(`mutation { updateService(id: ${ row.id }, name: "${ row.name }", description: "${ row.description }", baseCost: ${ row.baseCost }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllService()
    })
  }

  @action deleteService(id) {
    this.ds.query(`mutation { deleteService(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllService()
    })
  }
}

export default new Service()



// WEBPACK FOOTER //
// ./src/stores/service.js